import Collapse from '@material-ui/core/Collapse'
import React from "react"
import Button from "../../components/UI/Button/Button"
import LocalSearch from "../../components/UI/Search/Search"
import Select from "../../components/UI/Select/Select"
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import FetchData from "../../shared/fetchData"

const KioskShifts = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [kioskShifts, setKioskShifts] = React.useState([])
    const [edit, setEdit] = React.useState(false)
    const [view, setView] = React.useState(false)
    const [showBunchForm, setShowBunchForm] = React.useState(false)
    const [kiosks, setKiosks] = React.useState([])
    const [kiosk, setKiosk] = React.useState('')
    const [shifts, setShifts] = React.useState([])
    const [shift, setShift] = React.useState('')
    const [bunch, setBunch] = React.useState('')


    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        setLoading(true)
        var raw = JSON.stringify({
            "kiosk": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/kiosks/getKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setKiosks(result.kiosks)
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "shift": {
            },
            "pl": '10000',
            "pn": '1',
            "version": "mtpx001"
        })
        var url = 'management/api/v1/shifts/getShifts'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setShifts(result.shifts)
                }
            })
            .catch(error => setLoading(false))
    }, []);

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "kioskShift": {
                "kiosk": {
                    id: kiosk?.value
                },
                "shift": {
                    id: shift?.value
                },
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskshifts/getKioskShifts'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.kioskShifts)
                    pushData(newList)
                    setKioskShifts(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }

    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'kioskDescription',
                header: "نام لاکر",
                align: 'center',
            },
            {
                accessorKey: 'startTime',
                header: "ساعت شروع",
                align: 'center',
            },
            {
                accessorKey: 'kioskType',
                header: "ساعت پایان",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                kioskDescription: d.kiosk?.description,
                startTime: d.shift?.startTime,
                endTime: d.shift?.endTime,
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        setKiosk('');
        setShift('');
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }
    const changeKiosk = selectedOption => {
        setKiosk(selectedOption)
    }
    const changeShift = selectedOption => {
        setShift(selectedOption)
    }
    const kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    const shiftList = []
    if (shifts != null && shifts.length != 0) {
        shifts.map(z => {
            shiftList.push({
                value: z.id,
                label: z.startTime + "-" + z.endTime
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <Select
                name="form-field-name"
                value={kiosk}
                placeholder="لاکر"
                options={kioskList}
                onChange={changeKiosk}
                col="3"
            />
            <Select
                name="form-field-name"
                value={shift}
                placeholder="شیفت"
                options={shiftList}
                onChange={changeShift}
                col="3"
            />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>

    return (
        <>
            {loading ? <Spinner /> : ''}
            <Collapse in={!showBunchForm}>
                <LocalSearch class="orders-search" form={form} />
                {/* {permission != null && permission.includes('KIOSK_WRITE') ?
                    <div className="row justify-content-center mt-3 ml-3">
                        <div className="UserGeneralBtn">
                            <div onClick={(event) => addNewBunch(event)} className="Add">
                                <Add className="UserIcon" />
                            </div>
                        </div>
                    </div>
                    : ''
                } */}
                {rerender ?
                    // <Spinner />
                    <Table hasDetails={false} data={kioskShifts} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                    :
                    <Table hasDetails={false} data={kioskShifts} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                }
            </Collapse>
            {/* <Collapse in={showBunchForm}>
                <BunchForm bunch={bunch} edit={edit}
                    toggleNewBunchForm={(event, value) => { setShowBunchForm(value) }}
                    toggleNewBunchFormAndReload={(event, value) => {
                        search();
                        setShowBunchForm(value);
                    }}
                />
            </Collapse> */}
        </>
    )
}
export default KioskShifts;